module.exports = __webpack_public_path__ + "/login_ui/img/mz-c1b9bea78c4e23af834208b077b767e2.svg";